import { Payor } from '@finpay-estimation/estimation-types';

/** Availity-capable payors from the current-insurance list (active + has plans). */
export function filterAvailityCurrentInsurancePayors(
  payors: Payor[],
  availityVobSourceId: number | null | undefined
): Payor[] {
  if (!availityVobSourceId) {
    return [];
  }
  return payors.filter(
    (payor) =>
      !!payor.payorSource?.some((ps) => ps.vobSourceId === availityVobSourceId) &&
      !!payor.plans?.length
  );
}

export function payorDisplayName(payor: Payor): string {
  return (payor.facilityPayorName || payor.payorName || '').trim();
}

export function findPayorById(
  payors: Payor[],
  payorId: number | null | undefined
): Payor | undefined {
  if (payorId == null || Number(payorId) === 0) {
    return undefined;
  }
  return payors.find((p) => Number(p.payorId) === Number(payorId));
}
